var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 11.8337H2.66671V3.83366H9.40004C9.34671 3.57366 9.28004 3.09366 9.40004 2.50033H2.66671C1.93337 2.50033 1.33337 3.10033 1.33337 3.83366V15.8337L4.00004 13.167H13.3334C14.0667 13.167 14.6667 12.567 14.6667 11.8337V5.82033C14.28 6.11366 13.8267 6.33366 13.3334 6.43366V11.8337Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.16699C13.7713 5.16699 14.6667 4.27156 14.6667 3.16699C14.6667 2.06242 13.7713 1.16699 12.6667 1.16699C11.5621 1.16699 10.6667 2.06242 10.6667 3.16699C10.6667 4.27156 11.5621 5.16699 12.6667 5.16699Z",
    fill: "#A1A1A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 9.16699H4.00004V10.5003H9.33337V9.16699Z",
    fill: "#A1A1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.16699H4.00004V8.50033H12V7.16699Z",
    fill: "#A1A1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 6.50033H12V6.43366C11.1934 6.26699 10.5 5.80033 10.02 5.16699H4.00004V6.50033Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadFilterIcon);
export default __webpack_public_path__ + "static/media/unread_filter_icon.ca56cb4979c6ee0c3d96c791fbf252f2.svg";
export { ForwardRef as ReactComponent };